(function () {
  function formatDate(date) {
    var weekdays = ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'];
    var months = ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];
    return weekdays[date.getDay()] + ' ' + date.getDate() + '. ' + months[date.getMonth()];
  }

  function shippingLabel() {
    var date = new Date();
    date.setDate(date.getDate() + 2);
    return formatDate(date);
  }

  function renderShippingDate() {
    var nodes = document.querySelectorAll('[data-hh-pr-date]');
    if (!nodes.length) return;
    var label = shippingLabel();
    nodes.forEach(function (node) {
      node.textContent = label;
      node.setAttribute('data-hh-pr-rendered', 'true');
    });
  }

  document.addEventListener('DOMContentLoaded', renderShippingDate);
  document.addEventListener('shopify:section:load', renderShippingDate);
  document.addEventListener('shopify:section:select', renderShippingDate);
  document.addEventListener('variant:change', renderShippingDate);
  document.addEventListener('product:variant-change', renderShippingDate);

  document.addEventListener('change', function (event) {
    var name = event.target && event.target.name;
    if (name === 'id' || name === 'options[]') window.setTimeout(renderShippingDate, 0);
  });

  var observer = new MutationObserver(function () {
    var node = document.querySelector('[data-hh-pr-date]');
    if (node && (!node.getAttribute('data-hh-pr-rendered') || /Beregner/i.test(node.textContent))) {
      renderShippingDate();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  function enableReveals() {
    var root = document.getElementById('hh-pr-page');
    if (!root || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.classList.add('hh-pr-motion');
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('hh-pr-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    root.querySelectorAll('[data-hh-pr-reveal]').forEach(function (node) {
      revealObserver.observe(node);
    });
  }

  document.addEventListener('DOMContentLoaded', enableReveals);
  document.addEventListener('shopify:section:load', enableReveals);
})();
